// Stub left in place after dark mode was removed.
// Returns constant "light" values so existing callers keep working
// without any conditional dark-mode branches firing.

const noop = () => {};

export const useTheme = () => ({
  theme: 'light',
  isDarkMode: false,
  setTheme: noop,
  toggleTheme: noop,
  themes: { light: 'light' },
});
